;(function(w, d){

  function initGallery() {

    const inst = d.getElementsByClassName('fame-dynamic-gallery'),
      progressC = d.getElementsByClassName('progressCont'),
      progress = d.getElementsByClassName("progressBar"),
      startNum = 12; // Number of Images to load initially

    let imageNum = 0,
      loadNum = 0;

    for (let i = 0; i < inst.length; i++) {
      d.querySelector('.standard-gallery').insertAdjacentHTML('beforeend',`<div class="dynamic-gallery-btns"><span id="loadMoreBtn" class="fg-btn btn btn--frame">Load More</span><span id="loadAllBtn" class="fg-btn btn btn--frame">Load All</span></div>`);
    }

    const moreBtn = d.getElementById('loadMoreBtn');
    const allBtn = d.getElementById('loadAllBtn');

    // TODO: check how this works with touch devices
    moreBtn.addEventListener('click', moreImages);
    allBtn.addEventListener('click', allImages);

    const preload = new createjs.LoadQueue(true);

    preload.on('progress', function() {
      const text = d.getElementsByClassName('progressText')[0];
      const percentage = Math.floor(this.progress * 100);
      const percentageString = percentage + "%";
      text.innerHTML = percentageString;
      gsap.to(progress[0], .1, {x: percentageString});
    })

    preload.on('complete', function() {
      progressC[0].classList.add('loadComplete');
      const items = preload.getItems();
      renderImages(items);
      preload.removeAll();
      let galleryLB = GLightbox({
        selector: '.lbItem',
        touchNavigation: true,
        loop:true
      });
    });

    function moreImages() {

      gsap.set(progress[0], {x: 0});
      progressC[0].classList.remove('loadComplete');
      let moreNum = loadNum + 12;
      const moreManifest = [];

      while (loadNum < moreNum && manifest.length > 0) {
        let nextItem = manifest.shift();
        for (const [key, value] of Object.entries(nextItem)) {
          if (key.startsWith('src-jpg')) {
            moreManifest.push(value);
          }
        }
        loadNum++;
      }

      preload.loadManifest(moreManifest);
    }

    moreImages();

    function allImages() {
      progressC[0].classList.remove('loadComplete');

      const moreManifest = [];

      while (manifest.length > 0) {
        let nextItem = manifest.shift();
        for (const [key, value] of Object.entries(nextItem)) {
          if (key.startsWith('src-jpg')) {
            moreManifest.push(value);
          }
        }
        loadNum++;
      }

      preload.loadManifest(moreManifest);
    }

    function renderImages(images) {

      let content = "<div class='flexGallery'>";

      images.forEach( (image) => {
        const imageBase = image.item.src.split('.')
        imageNum++;
        content += '<a href="' + image.item.src + '" class="fame-gallery-item-' + imageNum + ' lbItem">' +
                  '<img src="' + image.item.src + '">' +
                  '</a>'
        ;
      });

      content += '</div>';

      for (let i = 0; i < inst.length; i++) {
        d.querySelector('.fame-dynamic-gallery').insertAdjacentHTML('beforeend',content);
      }

      var el = d.getElementsByClassName('fame-gallery-cont')[0];
      if (imageNum >= manifest.length) {
        gsap.to(".dynamic-gallery-btns", .2, {text:"All Images Loaded"}, '-=.4');
      }
    }

  }

  // only run the gallery function if a manifest exists.
  if (typeof manifest === 'undefined' || manifest.length < 1) {
    gsap.to('.progressCont', .2, {autoAlpha:0});
    document.querySelector('.fame-dynamic-gallery').append('There are no images for this event right now. Come back soon!')
  } else if (typeof manifest !== 'undefined') {
    initGallery();
  }

})(window, document);
